module.exports = __webpack_public_path__ + "static/media/blink-eye-closed.02335ea9.png";